import PropTypes from 'prop-types'
import styled from 'styled-components'

import CardData from '../../game/Card'

import ResourceIcon from './ResourceIcon'

const CardCost = styled.div`
    display: flex;
    justify-content: start;
`
const CardWrapper = styled.div`
    margin: 8px;
    box-sizing: border-box;
    width: 320px;
    height: 440px;
    border-radius: 5%;
    padding: 12px;
    background: grey;
    position: relative;
`

const CardTitle = styled.p`
    margin: 2px 0;
    font-size: 18px;
    font-weight: 700;
    text-align: center;
`

const CardImg = styled.img`
    background: lightgrey;
    display: block;
    width: 100%;
    height: 200px;
`

const CardDescription = styled.p`
    background: lightgrey;
    height: 84px;
    padding: 4px;
    overflow-x: wrap;
    overflow-y: scroll;
`

const CardEarnings = styled.div`
    display: flex;
    justify-content: end;
`

function Card(props) {
    const { data, ...passThroughProps } = props

    return (
        <CardWrapper {...passThroughProps}>
            <CardCost>
                {data.cost.map((resource, index) => {
                    return <ResourceIcon key={index} resource={resource} />
                })}
            </CardCost>
            <CardTitle>{data.title}</CardTitle>
            <CardImg src={data.img} alt={data.alt} />
            <CardDescription>{data.description}</CardDescription>
            <CardEarnings>
                {data.earnings.map((resource, index) => {
                    return <ResourceIcon key={index} resource={resource} />
                })}
            </CardEarnings>
        </CardWrapper>
    )
}

Card.propTypes = {
    data: PropTypes.instanceOf(CardData)
}

export default Card